var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"id":"inspire"}},[_c('h2',[_vm._v("Indicadores de Capacitación")]),_c('v-card',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.miHtml)}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }